// src/registered/site-admin/components/Workflow-esg/controllers/TemplateMetadataController.js
import { GenericFileUploader } from "../../../../upload/services/genericFileUploader";
import { executeWorkflowHandshake } from "../../Workflow-esg/Workflow_XLS_Support";

export class TemplateMetadataController {
    constructor(userId, siteKey) {
        this.userId = userId;
        this.siteKey = siteKey || process.env.REACT_APP_SITE_KEY;
    }

    /**
     * 🎯 READ: Fetches the mirrored JSON from S3 via the BFF proxy.
     * Logic: We bypass the 'InfraExists' directory check because the 
     * TemplateDefinitionController has already verified the folder's existence.
     */
    async loadMetadata(taxonomyName) {
        const structureFileName = `${taxonomyName}_Structure_Definition_meta.json`;
        console.group(`🔍 [METADATA_LOAD]: ${taxonomyName}`);
        
        try {
            const payload = {
                action: "READ_JSON_OBJECT", // 🎯 Direct read of the specific file
                user_id: this.userId,
                payload: {
                    bucketName: process.env.REACT_APP_SITE_TEMPLATE_BUCKET || "esg-template-management",
                    key: `${taxonomyName}/BaseStructure/${structureFileName}`
                }
            };

            const response = await executeWorkflowHandshake(
                "doorman/InfraExists", 
                payload, 
                "InfraExists"
            );
            
            if (response?.data) {
                console.log("✅ [MIRROR_FOUND]: Data hydrated from S3.", response.data);
            } else {
                console.warn("⚠️ [MIRROR_MISSING]: No existing metadata file found.");
            }
            
            console.groupEnd();
            return response?.data; // Returns the parsed JSON or null
        } catch (err) {
            console.error("🚨 [LOAD_FAILED]:", err.message);
            console.groupEnd();
            return null;
        }
    }

    /**
     * 🎯 WRITE: Orchestrates the Mirror-to-S3 sync using the GenericFileUploader.
     * This overwrites the existing file on S3 while appending to the change_log.
     */
    async saveStructureDefinition(templateData, selectedFile, existingHistory = []) {
        const taxonomyName = selectedFile?.filename?.split('.')[0] || "Unknown_Taxonomy";
        const version = "01_01"; 
        const structureFileName = `${taxonomyName}_Structure_Definition_meta.json`;

        console.group(`📡 [METADATA_SYNC]: ${structureFileName}`);
        console.log("📦 [PREPARING_MIRROR]: Compiling Change Log and Snapshot...");

        const definitionMirror = {
            definition_metadata: {
                file_name: structureFileName,
                version: version,
                taxonomy_anchor: taxonomyName,
                site_key: this.siteKey
            },
            current_state: {
                description: templateData.description,
                valid_from: templateData.validFrom,
                status: "PROVISIONED",
                created_by: this.userId
            },
            change_log: [
                {
                    v: version,
                    timestamp: new Date().toISOString(),
                    user: this.userId,
                    action: "STRUCTURE_DEFINITION_SAVE",
                    snapshot: { 
                        desc: templateData.description, 
                        date: templateData.validFrom 
                    }
                },
                ...existingHistory // Preserves historical snapshots
            ]
        };

        const uploadConfig = {
            bucketName: process.env.REACT_APP_SITE_TEMPLATE_BUCKET || "esg-template-management",
            fileName: `${taxonomyName}/BaseStructure/${structureFileName}`,
            batchType: 2, 
            labels: ["Metadata", "Structure Definition", version]
        };

        try {
            const result = await GenericFileUploader.uploadGeneratedData(definitionMirror, uploadConfig);
            console.log("🏆 [SYNC_COMPLETE]: S3 Overwrite successful.");
            console.groupEnd();
            return result;
        } catch (err) {
            console.error("🚨 [METADATA_CONTROLLER_ERROR]:", err.message);
            console.groupEnd();
            throw err;
        }
    }
}